module.exports = __webpack_public_path__ + "static/media/location.f34c00e7.png";